/**
 * Demo fournisseurs — wholesalers + direct laboratoire accounts. Includes
 * both linked-to-Pharmakon (compte_fournisseur_id) and manual records.
 */
export function buildFournisseurs() {
  return [
    {
      id: "frn-001",
      nom: "SOPHARM Algérie",
      type: "GROSSISTE",
      adresse: "Zone Industrielle, Réghaïa",
      ville: "Alger",
      wilaya: "Alger",
      telephone: "+213 21 86 11 22",
      email: "commandes@sopharm.dz",
      nif: "099816112233445",
      rc: "16/01-7654321",
      note: 4.6,
      compte_fournisseur_id: "ext-acct-1",
      conditions_paiement: "30 jours net",
      created_at: "2024-02-01T09:00:00.000Z",
    },
    {
      id: "frn-002",
      nom: "GROSPHARMA",
      type: "GROSSISTE",
      adresse: "12 Bd des Martyrs",
      ville: "Alger",
      wilaya: "Alger",
      telephone: "+213 21 73 14 25",
      email: "info@grospharma.dz",
      nif: "099816114455667",
      rc: "16/02-1234567",
      note: 4.2,
      compte_fournisseur_id: "ext-acct-2",
      conditions_paiement: "45 jours net",
      created_at: "2024-02-05T09:00:00.000Z",
    },
    {
      id: "frn-003",
      nom: "Saidal Distribution",
      type: "LABORATOIRE",
      adresse: "Route Nationale n°5",
      ville: "El Harrach",
      wilaya: "Alger",
      telephone: "+213 21 67 80 80",
      email: "distrib@saidal.dz",
      nif: "099816117788990",
      rc: "16/03-0000123",
      note: 4.9,
      compte_fournisseur_id: "ext-acct-3",
      conditions_paiement: "Comptant",
      created_at: "2024-01-20T09:00:00.000Z",
    },
    {
      id: "frn-004",
      nom: "Biopharm Distribution",
      type: "LABORATOIRE",
      adresse: "Cité Boumkik",
      ville: "Oued Smar",
      wilaya: "Alger",
      telephone: "+213 21 32 50 90",
      email: "ventes@biopharm.dz",
      nif: "099816119900112",
      rc: "16/04-0000456",
      note: 4.7,
      compte_fournisseur_id: "ext-acct-4",
      conditions_paiement: "30 jours net",
      created_at: "2024-01-25T09:00:00.000Z",
    },
    {
      id: "frn-005",
      nom: "PharmaCenter Ouest",
      type: "GROSSISTE",
      adresse: "Bd de l'Indépendance",
      ville: "Oran",
      wilaya: "Oran",
      telephone: "+213 41 33 22 11",
      email: "contact@pharmacenter-ouest.dz",
      nif: "099831117788000",
      rc: "31/05-9876543",
      note: 4.1,
      compte_fournisseur_id: null,
      conditions_paiement: "60 jours net",
      created_at: "2024-03-10T09:00:00.000Z",
    },
    {
      id: "frn-006",
      nom: "El Kendi Pharma",
      type: "LABORATOIRE",
      adresse: "Cité industrielle",
      ville: "Sétif",
      wilaya: "Sétif",
      telephone: "+213 36 91 78 90",
      email: "commercial@elkendi.dz",
      nif: "099819118899221",
      rc: "19/06-1112223",
      note: 4.4,
      compte_fournisseur_id: "ext-acct-5",
      conditions_paiement: "45 jours net",
      created_at: "2024-02-18T09:00:00.000Z",
    },
    {
      id: "frn-007",
      nom: "Merinal Algérie",
      type: "LABORATOIRE",
      adresse: "Z.I. Rouiba",
      ville: "Alger",
      wilaya: "Alger",
      telephone: "+213 21 85 30 40",
      email: "contact@merinal.dz",
      nif: "099816112344556",
      rc: "16/07-2334455",
      note: 4.3,
      compte_fournisseur_id: null,
      conditions_paiement: "Comptant",
      created_at: "2024-04-02T09:00:00.000Z",
    },
    {
      id: "frn-008",
      nom: "Hydra Médical",
      type: "DEPOSITAIRE",
      adresse: "12 chemin du Beaulieu",
      ville: "Hydra",
      wilaya: "Alger",
      telephone: "+213 21 60 25 80",
      email: "info@hydra-medical.dz",
      nif: "099816117654321",
      rc: "16/08-4455667",
      note: 3.9,
      compte_fournisseur_id: null,
      conditions_paiement: "15 jours net",
      created_at: "2024-05-15T09:00:00.000Z",
    },
  ];
}
